import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AgentChat } from "@/features/chat/components/agent-chat";

export const Route = createFileRoute("/chat/_layout/")({
  component: ChatIndexRoute,
});

/**
 * MIN-240: bare `/chat` — an empty new-chat composer, centred on an otherwise
 * blank page. `AgentChat.Root` is forced to `threadId={null}` so it always
 * renders the empty composer regardless of the store's `activeThreadId` —
 * this route never redirects to a last-touched thread. Submitting reuses the
 * panel's existing create-then-send path (pending-message stash, thread
 * create, consume on mount); `onThreadChange` here just navigates to the new
 * thread's URL once it exists.
 */
function ChatIndexRoute() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="w-full">
        <AgentChat.Root
          threadId={null}
          onThreadChange={(threadId) => {
            if (threadId !== null) {
              navigate({ to: "/chat/$threadId", params: { threadId } });
            }
          }}
        >
          <AgentChat.PromptInput placeholder="What would you like to know?" />
        </AgentChat.Root>
      </div>
    </div>
  );
}
